<template>
  <v-container id="usuariospedidos" tag="section">
    <base-v-component :heading="nombreUsuario" />
    <base-material-card
      color="indigo"
      icon="mdi-account-multiple"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click="goUsuario()"
          >Volver al usuario</v-btn
        >
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          hide-details
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="pedidos"
        :loading="loading"
        :search="search"
      >
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                small
                v-on="on"
                @click="goPedido(item)"
              >
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver pedido</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { mostrarMoneda } from "@/utils/utils.js";
import moment from "moment";

export default {
  data() {
    return {
      pedidosBruto: [],
      headers: [
        {
          sortable: false,
          text: "ID",
          value: "id",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fechaMostrar",
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "restauranteMostrar",
        },
        {
          sortable: false,
          text: "Cantidad",
          value: "cantidadMostrar",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      loading: false,
      search: "",
    };
  },
  computed: {
    nombreUsuario() {
      return this.usuarioBruto
        ? "Pedidos del usuario " + this.usuarioBruto.displayName
        : "Cargando Usuario";
    },
    ...mapState({
      usuarioBruto: (state) => state.users.usuarioViendo,
    }),
    pedidos() {
      return this.pedidosBruto.map((p) => {
        return {
          ...p,
          restauranteMostrar:
            !!p.copyRest && !!p.copyNegocio
              ? p.copyNegocio.nombre + " " + p.copyRest.nombre
              : p.restaurante,
          fechaMostrar: p.fechaServidor
            ? moment(p.fechaServidor.toDate()).format("YYYY-MM-DD HH:mm")
            : "-",
          cantidadMostrar: p.precioTotal ? mostrarMoneda(p.precioTotal) : "-",
        };
      });
    },
  },
  methods: {
    goPedido(item) {
      let str = "/admin/pedidos/view/" + item.id;
      this.$router.push(str);
    },
    goUsuario() {
      this.$router.push("/admin/usuario/" + this.usuarioBruto.id);
    },
    getUser() {
      return this.$store
        .dispatch("users/getUsuario", this.$route.params.idusuario)
        .catch((e) => {
          console.log(e);
          this.$router.push("/admin/panel");
        });
    },
    getPedidosUsers() {
      return this.$store.dispatch("users/getPedidosUsuario").then((r) => {
        this.pedidosBruto = r;
      });
    },
  },
  mounted() {
    this.loading = true;
    this.getUser()
      .then(() => this.getPedidosUsers())
      .finally(() => (this.loading = false));
  },
};
</script>

<style>
</style>